module.exports = __webpack_public_path__ + "img/image_7.58d3a9d2.png";